<template>
  <v-badge class="archive-add-access-icon-badge"
           location="top left"
           :bordered="true"
           color="#646c73"
           :offset-x="-7"
           :offset-y="-5"
           :model-value="!isArchivingEnabled"
           icon="fa-crown"
  >
    <app-material-icon name="inventory_2" :size="size" color="inherit" />
  </v-badge>
</template>

<script>
export default {
  name: 'ArchiveAddAccessIcon',
  props: {
    isArchivingEnabled: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: 'sm',
    },
  },
}
</script>

<style lang="scss" scoped>
.archive-add-access-icon-badge :deep(.v-badge__badge) {
  height: 16px;
  min-width: 16px;
  font-size: 14px;
  padding: 0 3px;

  & .v-icon {
    font-size: 8px;
    width: 12px;
    height: 12px;
    color: white !important;
  }
}
</style>
